import React from 'react';
export const Badge = ({
  children,
  className = ''
}: any) => <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-zano-lavender text-zano-charcoal ${className}`} data-id="element-1914">
    {children}
  </span>;